import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ChatIcon from '@mui/icons-material/Chat';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { trackEvent } from './trackingService'; // Import the tracking service

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const iconMap = {
    Haven: {
      active: <HomeIcon />,
      default: <HomeOutlinedIcon />
    },
    Oracle: {
      active: <ChatIcon />,
      default: <ChatBubbleOutlineIcon />
    },
    Wallet: {
      active: <AccountBalanceWalletIcon />,
      default: <AccountBalanceWalletOutlinedIcon />
    },
    Me: {
      active: <AccountCircleIcon />,
      default: <AccountCircleOutlinedIcon />
    }
  };

  const navItems = [
    { label: 'Haven', value: '/' },
    { label: 'Oracle', value: '/chat-sessions' },
    { label: 'Wallet', value: '/star-light' },
    { label: 'Me', value: '/account' }
  ];

  const handleChange = (event, newValue) => {
    trackEvent(newValue); // Track the navigation event
    navigate(newValue);
  };

  return (
    <Box className="bottom-navigation">
      <BottomNavigation
        value={currentPath}
        onChange={handleChange}
        showLabels
        sx={{ height: 60 }}
      >
        {navItems.map((item) => (
          <BottomNavigationAction
            key={item.label}
            label={item.label}
            value={item.value}
            icon={currentPath === item.value ? iconMap[item.label].active : iconMap[item.label].default}
            className={currentPath === item.value ? 'active-tab' : ''}
            sx={{
              backgroundColor: currentPath === item.value ? '#f9f9f9' : 'transparent',
              '& .MuiBottomNavigationAction-label': {
                color: currentPath === item.value ? '#1d8a1c' : '#666666',
                fontWeight: currentPath === item.value ? '500' : '400',
                fontFamily: 'Ubuntu, sans-serif',
                fontSize: currentPath === item.value ? '16px' : '14px',
              },
              '& .MuiSvgIcon-root': {
                color: currentPath === item.value ? '#1d8a1c' : '#666666',
                fontSize: currentPath === item.value ? '24px' : '24px',
                fontFamily: 'Ubuntu, sans-serif',
              },
              '&.active-tab::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100%',
                height: '3px',
                backgroundColor: '#1d8a1c',
                borderRadius: '0px',
              },
            }}
          />
        ))}
      </BottomNavigation>
    </Box>
  );
}

export default BottomNav;
